import React, { useState } from 'react';
import './style.scss';
import UQIcon from '../icon';

export interface UQMenuItem {
  text: string;
  icon?: string;
  url?: string;
  disabled?: boolean;
  subItems?: UQMenuItem[];
}

export interface UQMenuProps {
  items: UQMenuItem[];
  onItemClick?: (item: UQMenuItem) => void;
  className?: string;
}

const UQMenu: React.FC<UQMenuProps> = ({ items, onItemClick, className = '' }) => {
  const [openSubMenu, setOpenSubMenu] = useState<string | null>(null);

  const handleItemClick = (item: UQMenuItem, event: React.MouseEvent) => {
    console.log('UQMenu handleItemClick called:', item);
    event.preventDefault();
    event.stopPropagation();
    
    if (item.disabled) {
      console.log('Item is disabled:', item);
      return;
    }
    
    if (item.subItems) {
      console.log('Item has subitems, toggling submenu');
      setOpenSubMenu(openSubMenu === item.text ? null : item.text);
    } else if (onItemClick) {
      console.log('Calling onItemClick with:', item);
      onItemClick(item);
    } else {
      console.log('No onItemClick handler provided');
    }
  };

  const renderMenuItems = (menuItems: UQMenuItem[], isSubMenu = false) => (
    <ul className={`uq-menu ${isSubMenu ? 'uq-submenu' : ''}`}>
      {menuItems.map((item) => (
        <li
          key={item.text}
          className={`uq-menu-item ${item.disabled ? 'disabled' : ''} ${
            openSubMenu === item.text ? 'open' : ''
          }`}
          onClick={(event) => handleItemClick(item, event)}
          onMouseDown={(event) => {
            console.log('MouseDown event:', item);
            // Fallback handler
            if (!item.disabled && !item.subItems && onItemClick) {
              handleItemClick(item, event);
            }
          }}
          style={{ userSelect: 'none' }}
        >
          <div className="uq-menu-item-content">
            {item.icon && <UQIcon icon={item.icon} />}
            <span>{item.text}</span>
            {item.subItems && <UQIcon icon={openSubMenu === item.text ? 'chevron-up' : 'chevron-down'} />}
          </div>
          {item.subItems && openSubMenu === item.text && renderMenuItems(item.subItems, true)}
        </li>
      ))}
    </ul>
  );

  return <nav className={`uq-menu-container ${className}`}>{renderMenuItems(items)}</nav>;
};

export default UQMenu;
